// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__38tQz","actionsCol":"EnrolledClinics_actionsCol__1_WdB"};